import _ from "lodash";
import { useEffect, useState } from "react";
import { getEquipmentJsonSchema, updateEquipmentJsonSchema, getSensorJsonSchema, updateSensorJsonSchema } from "../../../../api/index";

const useJsonSchema = () => {

    const [initialEquipmentJsonContent, setInitialEquipmentJsonContent] = useState("{}");
    const [equipmentJsonContent, setEquipmentJsonContent] = useState("{}");
    const [initialSensorJsonContent, setInitialSensorJsonContent] = useState("{}");
    const [sensorJsonContent, setSensorJsonContent] = useState("{}");

    useEffect(() => {
        (async () => {
            const response = await getEquipmentJsonSchema();
            if (response?.data?.statusCode === 200) {
                if (response.data.data) {
                    setEquipmentJsonContent(JSON.stringify(response.data.data, null, 2));
                    setInitialEquipmentJsonContent(JSON.stringify(response.data.data, null, 2))
                }
            }
        })();

        (async () => {
            const response = await getSensorJsonSchema();
            if (response?.data?.statusCode === 200) {
                if (response.data.data) {
                    setSensorJsonContent(JSON.stringify(response.data.data, null, 2));
                    setInitialSensorJsonContent(JSON.stringify(response.data.data, null, 2))
                }
            }
        })();
    }, []);

    const setEquipmentContent = (content) => {
        if(!_.isEmpty(content)) {
            if(typeof content === 'string') {
                setEquipmentJsonContent(content);
            } else if(typeof content === 'object' && !_.isArray(content)) {
                setEquipmentJsonContent(JSON.stringify(content, null, 2));
            }
        }
    }

    const setSensorContent = (content) => {
        if(!_.isEmpty(content)) {
            if(typeof content === 'string') {
                setSensorJsonContent(content);
            } else if(typeof content === 'object' && !_.isArray(content)) {
                setSensorJsonContent(JSON.stringify(content, null, 2));
            }
        }
    }

    const updateEquipmentContentToRemote = async (callBack) => {
        if(!_.isEmpty(equipmentJsonContent)) {
            const response = await updateEquipmentJsonSchema(JSON.parse(equipmentJsonContent));
            callBack(response?.data?.statusCode);
            return response?.data?.statusCode === 200 && response?.data?.data;
        }
    }

    const updateSensorContentToRemote = async (callBack) => {
        if(!_.isEmpty(sensorJsonContent)) {
            const response = await updateSensorJsonSchema(JSON.parse(sensorJsonContent));
            callBack(response?.data?.statusCode);
            return response?.data?.statusCode === 200 && response?.data?.data;
        }
    }

    return {
        equipmentContent: equipmentJsonContent,
        setEquipmentContent: setEquipmentContent,
        initialEquipmentJsonContent: initialEquipmentJsonContent,
        updateEquipmentContentToRemote: updateEquipmentContentToRemote,
        sensorContent: sensorJsonContent,
        setSensorContent: setSensorContent,
        initialSensorJsonContent: initialSensorJsonContent,
        updateSensorContentToRemote: updateSensorContentToRemote
    }

}

export default useJsonSchema;